class QRCode {
  private static qrcodeMap: Map<string, { [key: string]: any }> = new Map();
  private static namespace = "_qrcode_";

  public static getQRCodeByKey(userID: number, key: string) {
    QRCode.ensure();
    const qrcode = QRCode.qrcodeMap.get(String(userID));
    if (qrcode && qrcode[key] && Date.now() < qrcode[key].expires) {
      return qrcode[key].value;
    }
    return null;
  }

  // max age == 1 hour
  public static setQRCode(
    userID: number,
    key: string,
    value: any,
    maxAge = 3600000
  ) {
    const qrcode = QRCode.qrcodeMap.get(String(userID));
    if (qrcode) {
      qrcode[key] = {
        value: value,
        expires: Date.now() + maxAge,
      };
    } else {
      QRCode.qrcodeMap.set(String(userID), { [key]: value });
    }
    QRCode.syncToStorage();
  }
  public static clearQRCode() {
    window.sessionStorage.removeItem(QRCode.namespace);
  }
  private static syncToStorage() {
    const obj: any = [];
    QRCode.qrcodeMap.forEach((value, key) => {
      obj.push({
        [key]: value,
      });
    });
    window.sessionStorage.setItem(QRCode.namespace, JSON.stringify(obj));
  }
  private static ensure() {
    if (QRCode.qrcodeMap.size < 1) {
      const qrcode = window.sessionStorage.getItem(QRCode.namespace);
      if (qrcode) {
        const records = JSON.parse(qrcode).map((item: any) => [
          Object.keys(item)[0],
          Object.values(item)[0],
        ]);
        QRCode.qrcodeMap = new Map(records);
      }
      // NOTE: ensure
      QRCode.qrcodeMap.set("-1", { __internal__: "hasInitiated" });
    }
  }
}

export default QRCode;
